import { msgbox } from "./smallarAlert.esm.js";
const help_info={
    "header_help":`使用步骤:<br>
                   选择数据集->添加样本数据到贝叶斯训练->自定义样本->数字化识别<br><br>
                   左侧下拉列表中选择系统数据集<br>
                   右边是数据集中的样本数据的缩略显示<br>
                   单击样本数据, 数据会添加到贝叶斯训练集中<br>
                   双击样本数据, 同类样本会依次添加到训练集中<br>
                   三击样本数据, 全部样本会依次添加到训练集中<br>

                   `,
    "editor_help":`左框代表数据的详情,系统内置数据样本,不可编辑<br>
                   右框代表待识别数据的详情, 可编辑<br>
                   左键单击翻转颜色, 右键清除颜色.<br><br>

                    按钮功能:<br>
                    克隆左侧:把左侧的样本数据克隆过来<br>
                    添加到数据集:把当前的数据添加为数据集,用于增加样本修正贝叶斯训练集<br>
                    特征序列化: 把当前样本数据序列化, 用于识别前的处理<br>
                    分类识别: 把当前数据与训练集数据进行比较, 用于识别属于哪一类<br>
                    识别计算原理:朴素贝叶斯与拉普拉斯优化,详见理论部分


                    `,
    "table_help":` 表格内的数据是贝叶斯计算过程中的数据详情<br>
                   特征表: 表格中显示添加到训练集中的样本数据<br>
                   概率表: <br> A 统计特征表中的各种类别的属性占比信息 <br>
                            B 仅显示各属性的占比信息<br>

                    两按钮可切换显示, 其中,概率表有以上两种显示模式.<br><br >

                    当添加了识别数据后, 会显示识别计算过程中的详情数据




                    `,
}

export {help_info}
